import React, { useEffect, useState } from "react";
import GitService from "../../services/gitlab";

export default function ConfigurationEnv({ projectId }) {
  const [envs, setEnvs] = useState({});

  const allowedKeys = [
    "HIDE_NEWSLETTER",
    "ENABLE_DISQUSS",
    "PLACENAME",
    "GATSBY_API_URL",
    "GATSBY_API_URL_V2",
    "GATSBY_SITE_URL",
  ];

  useEffect(() => {
    const configrationSettings = async () => {
      if (!projectId) return;

      try {
        const response = await GitService.getEnvFile(projectId);
        if (response.data?.content) {
          const decodedString = atob(response.data.content);

          const envObject = decodedString.split("\n").reduce((acc, line) => {
            let [label, value] = line.split("=");
            if (label && value) {
              acc[label.trim()] = value.trim();
            }
            return acc;
          }, {});

          const filteredEnvs = Object.fromEntries(
            Object.entries(envObject).filter(([key]) => allowedKeys.includes(key))
          );

          setEnvs(filteredEnvs);
        }
      } catch (error) {
        console.error("Error fetching env file:", error);
      }
    };

    configrationSettings();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  return (
    <details className="card" open="">
      <summary className="card-header">
        <h5 className="h3 card-title">Configuration Settings (Develop)</h5>
      </summary>
      <div className="card">
        <div className="row p-3">
          {Object.entries(envs).map(([label, value], index) => (
            <div key={label} className="col-md-4 mb-3">
              <div
                className={`card shadow-sm p-3 ${
                  index % 2 === 0 ? "bg-light" : "bg-white"
                }`}
                style={{ borderRadius: "10px" }}
              >
                <div className="card-body d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="fw-bold text-primary">
                      {label.replace(/_/g, " ")}
                    </h6>
                    <p className="mb-0 text-muted">{value}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </details>
  );
}
